import { __assign } from "tslib";
import { testDataCreator } from '@wix/answers-lib';
var timeZone = 'UTC';
export var createCallCenterAnalyticsFilterDto = testDataCreator({
    startDate: '1988-31-10',
    endDate: '1988-31-10',
    timeZone: timeZone
});
export var createGetCallCenterOverviewDto = testDataCreator(function () { return (__assign({ metrics: [] }, createCallCenterAnalyticsFilterDto())); });
export var createOverviewStats = testDataCreator(function () { return ({}); });
export var createOverviewStatsComparison = testDataCreator(function () { return ({
    value: createOverviewStats(),
    compared: createOverviewStats()
}); });
//# sourceMappingURL=builders.js.map